module.exports = __webpack_public_path__ + "img/img-1.9689e7a7.webp";